import { Component, ViewChild, ElementRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

import { AppLoginModalComponent } from '../app-login/app-login.component'
import { CopyrightAlertComponent } from '../shared/copyright-alert/copyright-alert.component';

import { DbService } from '../../db.service';
import { SessionService } from '../../session.service';
import { SpinnerService } from '../../spinner.service';
import { CopyrightAlertService } from '../../services/copyright-alert.service';
import { PowerBIConfig } from '../../interfaces/powerbi-config.interface';

import { ScrollToConfigOptions, ScrollToService } from '@nicky-lenaers/ngx-scroll-to';

declare var powerbi: any;

@Component({
    selector: 'app-boletim',
    templateUrl: './boletim.component.html',
    styleUrls: ['./boletim.component.css']
})

export class BoletimComponent {
    @ViewChild("login") login: AppLoginModalComponent;
    @ViewChild('embeddedReport') embeddedReport: ElementRef;
    config: PowerBIConfig;
    modalRef: BsModalRef;

    showBloqueio: boolean = false;

    constructor(
        private _scrollToService: ScrollToService,
        private dbService: DbService,
        private sessionService: SessionService,
        private spinnerService: SpinnerService,
        private modalService: BsModalService,
        private copyrightAlertService: CopyrightAlertService
    ) {
        this.fnPesquisar();
    }

    showCopyrightAlert(): void {
        // Reseta o estado de copyright para forçar nova aceitação
        this.copyrightAlertService.resetCopyrightAcceptance();
        
        this.modalRef = this.modalService.show(CopyrightAlertComponent, {
            class: 'modal-dialog-centered',
            backdrop: 'static',
            keyboard: false
        });

        // Aguarda o usuário aceitar os termos
        this.copyrightAlertService.copyrightAccepted$.subscribe(accepted => {
            if (accepted) {
                this.loadPowerBIReport();
            }
        });
    }

    fnPesquisar() {
        const sessao = JSON.parse(sessionStorage.getItem('sessao_usuario')  || '{}');

        this.dbService.post('EmbedInfo/VerificaPermissaoBoletim', this.sessionService.usuario.hash).subscribe(resultComum => {
            if (!resultComum.permissao) 
            {
                this.fnScrollTo();
                this.showBloqueio = true;
              } else {
                  // Se tem permissão, sempre mostra o pop-up de copyright
                  this.showCopyrightAlert();
              }
        });
    }

    loadPowerBIReport(): void {
        this.dbService.get('EmbedInfo/GetBoletimOpen').subscribe(result => {
            var pages = [];
            const model = window['powerbi-client'].models;
            
            this.config = result;
                            
            const embedConfig = {
                type: 'report',
                tokenType: model.TokenType.Embed,
                accessToken: result.embedToken.token,
                embedUrl: result.embedReport[0].embedUrl,
                permissions: model.Permissions.All,
                settings: {
                    filterPaneEnabled: false,
                    navContentPaneEnabled: false,
                    layoutType: model.LayoutType.Custom,
                    customLayout: {
                        displayOption: model.DisplayOption.FitToWidth
                    }
                }
            }
            
            var report = powerbi.embed(this.embeddedReport.nativeElement, embedConfig);
            report.fullscreen();
        });
    }

    fullscreen() {
        // Get a reference to the embedded report HTML element
        var embedContainer = this.embeddedReport.nativeElement

        // Get a reference to the embedded report.
        var report = powerbi.get(embedContainer);

        // Displays the report in full screen mode.
        report.fullscreen();
    }

    fnScrollTo() {
        const config: ScrollToConfigOptions = {
            target: 'resultado',
            offset: -97
        };
      
        this._scrollToService.scrollTo(config);
    }

}
